var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { AdminUsersPageAFY } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import React from "react";
import { AdminRolesDTO } from "../constanst/adminRolesDTO";
export var AdminRolView = function (props) {
    var _a, _b;
    return (_jsx(AdminUsersPageAFY, __assign({}, AdminRolesDTO, { drawerProps: __assign(__assign({}, AdminRolesDTO.drawerProps), { openDrawer: props.openDrawer, titleButton: props.permissionsRows.length > 0
                ? "Editar Permisos"
                : "Agregar Permisos" }), paginationProps: __assign(__assign({}, AdminRolesDTO.paginationProps), { count: props.countData, rowsPerPages: props.limit, pagePagination: props.page }), tableProps: __assign(__assign({}, AdminRolesDTO.tableProps), { rows: (_a = props.permissionsRows) !== null && _a !== void 0 ? _a : [] }), viewGridProps: __assign(__assign({}, AdminRolesDTO.viewGridProps(props.onOptionsCardClick)), { rows: (_b = props.rolesData) !== null && _b !== void 0 ? _b : [] }), permissions: {
            create: true,
            delete: true,
            update: true,
        }, userData: props.rolesData, onClickContextMenu: props.onOptionsCardClick, onChangePage: props.onChangePage, onChangeRowsPerPage: props.onChangeLimit, onClickButtonEditRoles: function () {
            props.setOpenDrawer(false);
            props.setOpenModalEdit(true);
        }, onCloseDrawer: function () { return props.setOpenDrawer(false); }, onChangeFilter: function (e) {
            props.setFiltersApplied(e);
        }, onClickAdd: function () {
            props.setOpenModalCreate();
        }, onBlurFullTextSearch: function () { }, onChangeFullTextSearch: function (e) { return props.setSearchQuery(e); }, onClickClearFilters: function () { } })));
};
